// extracted by mini-css-extract-plugin
module.exports = {"iframe":"EmbedBlock_iframe__HC0Fx","fourBy3":"EmbedBlock_fourBy3__ukykV","square":"EmbedBlock_square__NY4Nu"};